export default function DonationFrequencies(){
    const one_time = "One-Time";
    const monthly = "Monthly";
    const annually = "Annually";

    return {one_time, monthly, annually};
}